import React from "react";
import styled, { css } from "styled-components";

const H1SuperStyle = css`
  font-family: ${({ theme }) => theme.fonts.grenette};
  font-weight: 400;
  color: ${({ theme, color }) => color || theme.colors.black};
  font-size: 3.75rem;
  line-height: 108%;
  letter-spacing: -3%;
  ${({ theme }) => theme.media.tabletUp`
    line-height: 104%;
    font-size: 5.75rem;
  `};
`;

const StyledText = styled.h1`
  ${H1SuperStyle}
`;

const H1Super = ({ children, className, color }) => {
  return (
    <StyledText color={color} className={className}>
      {children}
    </StyledText>
  );
};

export default H1Super;
export { H1SuperStyle };
